import React, { useRef, useState } from "react";
import { signIn, auth } from "../data/auth";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./LoginPage.css";

import { ensureAllowlistedOrAct } from "../data/allowlist";
import BlobsField from "../components/BlobsField";

const LOGO_SRC = "/ccm-logo.png";
const VERSION_NUMBER = "Version 4.2.1";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [msg, setMsg] = useState("");
  const canvasRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    try {
      await signIn(email, password);

      const uidBefore = auth.currentUser?.uid || "unknown";
      const res = await ensureAllowlistedOrAct({
        emailFallback: email,
        signOutOnBlock: true,
        redirect: null,
      });

      if (!res.allowlisted) {
        setMsg(
          `Access restricted. Ask an admin to add your UID (${uidBefore}) to the allowlist.`
        );
        return;
      }

      setMsg("Signed in ✓");
      window.location.replace("/add");
    } catch (err) {
      setMsg(err?.message || "Authentication failed");
    }
  };

  const togglePassword = () => setShowPassword((prev) => !prev);

  return (
    <div
      className="login"
      style={{
        minHeight: "100dvh",
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        overflow: "visible",
      }}
    >
      {/* Centered login card */}
      <div className="glass-card">
        <div className="login__heroWrap">
          <img
            className="login__hero"
            src={LOGO_SRC}
            alt="CCM Coatings"
            draggable="false"
            loading="eager"
            decoding="async"
          />
        </div>
        <header className="login__header">
          <h1 className="login__title">Sign In</h1>
          <p className="login__subtitle">CCM Tinting Studio</p>
        </header>

        <form className="login__form" onSubmit={handleSubmit}>
          <label className="login__label">Email</label>
          <input
            type="email"
            autoComplete="username"
            className="login__input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label className="login__label">Password</label>
          <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              autoComplete="current-password"
              className="login__input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span className="toggle-password" onClick={togglePassword}>
              {showPassword ? <FaEye /> : <FaEyeSlash />}
            </span>
          </div>

          {msg && <div className="login__msg">{msg}</div>}
          <button type="submit" className="login__btn">Sign in</button>
        </form>
        <div className="login__version">{VERSION_NUMBER}</div>
      </div>

      {/* Background blobs: fixed, full-viewport; no layout impact */}
      <BlobsField
        ref={canvasRef}
        className="login__blobfield"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          zIndex: 0,
          pointerEvents: "none",
          background: "transparent",
        }}
      />
    </div>
  );
}
